import { CSSProperties } from 'react';
import { Layout } from 'design-system';

import { useOffSetTop } from 'src/hooks/use-off-set-top';
import { useResponsive } from 'src/hooks/use-responsive';

import { Logo } from 'src/components/logo';

import { HEADER } from '../config-layout';

// ----------------------------------------------------------------------

export default function HeaderSimple() {
  const offsetTop = useOffSetTop(HEADER.H_DESKTOP);
  const isMobile = !useResponsive('up', 'md');

  const getHeaderHeight = () => {
    if (isMobile) return HEADER.H_MOBILE;
    if (offsetTop) return HEADER.H_DESKTOP_OFFSET;
    return HEADER.H_DESKTOP;
  };

  const headerStyle: CSSProperties = {
    position: 'fixed',
    top: 0,
    zIndex: 1000,
    width: '100%',
    backgroundColor: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: getHeaderHeight(),
    padding: '0 24px',
    transition: 'height 200ms cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: offsetTop ? '0 8px 16px rgba(0,0,0,0.08)' : 'none',
  };

  return (
    <Layout.Header style={headerStyle}>
      <Logo />
    </Layout.Header>
  );
}
